// แชท: /chats/<uid>/<chatId> = {title, model, createdAt, updatedAt, pinned} · /messages/<chatId>/<msgId> = {role, content, model, cost, at}
import { db, fk, nowIso, newId } from "./db";

export const chats = {
  async list(uid) {
    const rows = await db.entries(`chats/${fk(uid)}`);
    return rows.map(([id, v]) => ({ id, ...v })).sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0) || (a.updatedAt < b.updatedAt ? 1 : -1));
  },
  get: (uid, id) => db.get(`chats/${fk(uid)}/${fk(id)}`),
  async create(uid, { title, model }) {
    const id = newId("c");
    const now = nowIso();
    await db.put(`chats/${fk(uid)}/${id}`, { title: title || "แชทใหม่", model, createdAt: now, updatedAt: now });
    return id;
  },
  rename: (uid, id, title) => db.patch(`chats/${fk(uid)}/${fk(id)}`, { title: String(title).slice(0, 80) }),
  pin: (uid, id, pinned) => db.patch(`chats/${fk(uid)}/${fk(id)}`, { pinned: !!pinned || null }),
  touch: (uid, id, patch = {}) => db.patch(`chats/${fk(uid)}/${fk(id)}`, { ...patch, updatedAt: nowIso() }),
  async remove(uid, id) {
    await db.update({ [`chats/${fk(uid)}/${fk(id)}`]: null, [`messages/${fk(id)}`]: null });
  },
  async messages(chatId) {
    const rows = await db.entries(`messages/${fk(chatId)}`);
    return rows.map(([id, v]) => ({ id, ...v }));
  },
  async addMessage(chatId, msg) {
    const id = newId("m");
    await db.put(`messages/${fk(chatId)}/${id}`, { ...msg, at: nowIso() });
    return id;
  },
};
